export const addExpendAndClone = (arr,defaultVal=[],newArr=[]) => {
    for (let i = 0; i < arr.length; i++) {
      for (const param of defaultVal) {
        arr[i][param.key] = arr[i][param.key] || param.val
      }
      let current = {}
      const {items=[],...other} = arr[i]
      current = {...other}
      if(items.length>0) {
          current.items = addExpendAndClone(items,defaultVal)
      } else {
        current.items = items
      }
      newArr.push(current)
    }
    return newArr 
  }
  // 获取当前节点之前的所有节点（包括当前节点）
  export const acquirebeforeAll = (arr,ancestor=[],hashObject={}) => {
    for (let i = 0; i < arr.length; i++) {
      ancestor.push(arr[i])
      hashObject[arr[i].auth_key] = [...ancestor]
      if(arr[i].items&&arr[i].items.length>0) {
        acquirebeforeAll(arr[i].items,ancestor,hashObject)
      }
      ancestor.pop()
    }
    return hashObject
  }

  // 获取当前节点只有的所有节点（不包括当前节点）
export const acquireAfterAll = (arr,level=0,hashObject={}) => {
  const childrenArr = []
  for (let i = 0; i < arr.length; i++) {
    childrenArr.push(arr[i])
    let rChilrenArr = []
    if(arr[i].items&&arr[i].items.length>0) {
      rChilrenArr = acquireAfterAll(arr[i].items,level+1,hashObject)
    }
    hashObject[arr[i].auth_key] = rChilrenArr
    childrenArr.push(...rChilrenArr)
  }
  if(level===0) return hashObject
  return childrenArr
}

// diff oldTree newTree
export const diffTree = (newTree,oldTree,{ defaultVals=[] }) => {
  const oldTreeHash = oldTree.reduce(function _reducer (total,childItem) {
    if(!childItem.app_token) {
      total[childItem.id] = childItem 
    }
    if(childItem.items&&childItem.items.length) {
      childItem.items.reduce(_reducer,total)
    }
    return total
  },{})
  return newTree.reduce(function _reducer (total,childItem) {
    const { app_token,items,...other } = childItem
    const oldChildItem = oldTreeHash[childItem.id]
    let obj = {}
    if(app_token) { // 根节点
       // eslint-disable-next-line
      const { items,...oldroot} = oldTree[0]
      obj = { ...oldroot,...other,app_token }
    }
    if(!app_token&&oldChildItem) { // 合并新旧节点
      // eslint-disable-next-line
      const { items: olditems, ...oldOther } = oldChildItem
      obj = {...oldOther,...other}
    }
    if(!app_token&&!oldChildItem) { // 旧树没有的全新节点
      obj = {...other}
      defaultVals.forEach(item => {
        obj[item.key] = item.val
      })
    }
    obj.items = []
    if(items&&items.length) { // 向下遍历
      obj.items = items.reduce(_reducer,[])
    }
    total.push(obj)
    return total
  },[])
}